import { render, staticRenderFns } from "./VerifyID.vue?vue&type=template&id=2927ed5f&"
import script from "./VerifyID.vue?vue&type=script&lang=js&"
export * from "./VerifyID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports